$(document).ready(function() {
  $('.styling-page-blog-posts ol').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});

document.querySelectorAll(".styling-contact-form p").forEach(p => {
    if (p.innerText.includes("Powered by Globo")) {
        p.style.display = "none";
    }
});


// document.addEventListener("DOMContentLoaded", function() {

//   // 1️⃣ If there are buttons to store the current URL and navigate
//   document.querySelectorAll(".product-care-detail").forEach(link => {
//     link.addEventListener("click", function(e) {
//       e.preventDefault();
//       const currentUrl = window.location.href;
//       localStorage.setItem("productUrl", currentUrl);
//       console.log("Stored URL:", currentUrl);

//       // Navigate to the target page
//       window.location.href = '/care-page'; // change to your page URL
//     });
//   });

//   // 2️⃣ On the target page, fetch care-section using stored URL
//   const storedUrl = localStorage.getItem("productUrl");

//   if (storedUrl) {
//     console.log("Fetched URL from localStorage:", storedUrl);

//     // Build URL to fetch the section from Shopify
//     const sectionUrl = storedUrl + "?section_id=care-section";

//     fetch(sectionUrl)
//       .then(response => {
//         if (!response.ok) throw new Error("Network response was not ok");
//         return response.text();
//       })
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, "text/html");
//         const sectionContent = doc.querySelector("#care-section");
//         if (sectionContent) {
//           const targetContainer = document.querySelector("#care-section-container");
//           if (targetContainer) {
//             targetContainer.innerHTML = sectionContent.innerHTML;
//           }
//           console.log("Care section loaded successfully!");
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching care-section:", error);
//       });

//     // Optionally, clear localStorage after use
//     localStorage.removeItem("productUrl");
//   }

// });


